import React, { useRef, Suspense, useState, useEffect } from 'react';
import { usePlane } from 'use-cannon';
import { Canvas, useFrame } from 'react-three-fiber';
import { TextureLoader, RepeatWrapping } from 'three';
import {OBJLoader} from "three/examples/jsm/loaders/OBJLoader";
import {ColladaLoader} from "three/examples/jsm/loaders/ColladaLoader";
import { useLoader } from 'react-three-fiber';
import grass from '../images/grass.jpg';
import dirt from '../images/dirt.jpg';
import { useStore } from '../hooks/useStore';
import * as THREE from "three";
import tomb_obj from "/Users/egrigokhan/Downloads/minecraft-react-master/src/tomb.obj";
import tomb_dae from "/Users/egrigokhan/Downloads/minecraft-react-master/src/tomb.dae";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { XYZLoader } from '/Users/egrigokhan/Downloads/minecraft-react-master/src/pc_viewer/XYZLoader.js';

export const Ground = (props) => {
  const [ref] = usePlane(() => ({ rotation: [-Math.PI / 2, 0, 0], ...props }));

  const tomb_mesh_ref = useRef();
  const [tombObject, setTombObject] = useState();

  /**
  useEffect(() => {
    const objLoader = new GLTFLoader();
    objLoader.load(tomb_gltf, (root) => {
      console.log("root", root)
      root.scene.position.set(0, 0, 0)
      root.scene.scale.set(0.01, 0.01, 0.01)
      // setTombObject(root.scene)
    });
  }, []);
  */

  useEffect(() => {
    const loader = new XYZLoader();
    loader.load( '/pp_pc.xyz', function ( geometry ) {

        console.log("geometry", geometry)
        geometry.center();

        const vertexColors = ( geometry.hasAttribute( 'color' ) === false );

                const material = new THREE.PointsMaterial( { color: "#FF0000", size: 0.05, vertexColors: vertexColors } );

        var points = new THREE.Points( geometry, material );
        points.scale.set(20, 20, 20);
        setTombObject( points );

    } );
    }, []);

    useFrame(() => {
      if(tombObject) {
        tombObject.rotateY(0.01)
      }
    })

  return (
    <group>
    <Suspense fallback={null}>{tombObject ? <primitive ref={tomb_mesh_ref} object={tombObject} position={[0, 0, 0]} /> : <></>}</Suspense>
    </group>
  );
};
